// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3L678","media":"styles_media__1WUZH","info":"styles_info__2m5IH","description":"styles_description__3ViTs","title":"styles_title__2zLPu"};